import css from 'styled-jsx/css';

const styles = css.global`@media (min-width: 1280px) {
  .ctn-home-24 {
    padding-right: 0;
    padding-left: 0;
  }
}
`;

export default styles;